import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

const KEY = "ba_cookie_consent";

export function CookieBanner() {
  const { slug } = useParams();
  const base = slug ? `/salon/${slug}` : "";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-[#0F0E0C]/95 backdrop-blur-xl border-t border-[#2C2A26]" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto px-6 py-5 flex flex-col md:flex-row md:items-center gap-4 justify-between">
        <p className="text-xs sm:text-sm text-[#A39E93] leading-relaxed">
          Ce site utilise uniquement des cookies essentiels à son bon fonctionnement (réservation, session). Aucun cookie publicitaire ou de traçage tiers n&apos;est déposé.{" "}
          <Link to={`${base}/confidentialite`} className="text-[#C5A059] hover:underline" data-testid="cookie-policy-link">En savoir plus</Link>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => decide("refused")} className="btn-secondary text-xs whitespace-nowrap" data-testid="cookie-refuse">Refuser</button>
          <button onClick={() => decide("accepted")} className="btn-primary text-xs whitespace-nowrap" data-testid="cookie-accept">J&apos;ai compris</button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
